import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Icon from "src/components/Icon";

interface AnnouncementBannerProps {
  onDismiss?: () => void;
}

const AnnouncementBanner = ({ onDismiss }: AnnouncementBannerProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();

  // Check if banner was previously dismissed
  useEffect(() => {
    const bannerDismissed = localStorage.getItem("guestListBannerDismissed");
    if (!bannerDismissed) {
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    // Store dismissal in localStorage so it doesn't show again
    localStorage.setItem("guestListBannerDismissed", "true");
    onDismiss?.();
  };

  // Only show banner on guest list pages
  const isGuestListPage =
    location.pathname === "/guests" &&
    (location.search.includes("tab=guestList") || !location.search);

  if (!isVisible || !isGuestListPage) return null;

  return (
    <div className="mb-4 rounded-lg border-primary-5 bg-primary-4 p-3 shadow-sm">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <div className="flex-shrink-0">
            <Icon iconName="info" />
          </div>
          <div className="flex-1">
            <p className="text-xs font-medium leading-relaxed text-primary-1 sm:text-sm">
              <strong>Update:</strong> Guests list now contains only guests that
              have been confirmed, to see all the people you invited check the{" "}
              <Link
                to="/invitations?tab=inviteList"
                className="text-primary-1 underline hover:text-primary-6"
              >
                Invite List
              </Link>{" "}
            </p>
          </div>
        </div>
        <button
          onClick={handleDismiss}
          className="ml-2 flex-shrink-0 text-secondary-3 transition-colors hover:text-primary-1"
          aria-label="Dismiss announcement"
        >
          <Icon iconName="close" />
        </button>
      </div>
    </div>
  );
};

export default AnnouncementBanner;
